<template>
  <div class="head">
    <div class="top_logo">
      <router-link :to="{ path: '/index' }" class="top_router">
        <!-- <div class="fanghui_box" v-if="isMobile && $route.path == '/my'">
          <router-link class="router" :to="{ path: '/index' }">
            <i class="el-icon-arrow-left"></i>
          </router-link>
        </div> -->
        <h2 v-if="APP_HOST === 'gpt4'">Hello, GPT4!</h2>
        <img src="@/assets/images/new/logo1.svg" class="logo_img" v-else />
        <!-- <h2></h2> -->
        <!-- <div v-if="$route.path=='/my'&&!isMobile"> | 个人中心</div> -->
      </router-link>

      <!-- <div class="menu">
          <router-link class="menu-item" to="/" :class="{active: $route.path == '/index'}">
              <span>首页</span>
          </router-link>
          <router-link class="menu-item" to="/apis" :class="{active: $route.path == '/apis'}">
              <img src="@/assets/images/new/apis.png">
          </router-link>
        </div> -->

      <div class="use_box">
        <router-link class="apis-link" to="/apis">
            <img src="@/assets/images/new/apis.png">
        </router-link>
        <a href="" class="qun" @click.prevent="wxDialogShow=true">
            <img src="@/assets/images/new/qun.svg">
            <p>交流群</p>
           </a>
        <div class="box name_box" v-if="!isMobile">
          <!-- v-if="account.account_type!='免费试用'" -->
          <el-tooltip
            popper-class="account_div"
            effect="light"
            placement="bottom-start"
            v-if="account.account_type != '初始用户'"
          >
            <div slot="content">
              <div class="account_box">
                我的套餐：{{ account.account_type }}
                <span class="lxkf" @click="toMy()">升级套餐</span>
              </div>
              <div class="account_box">
                剩余次数：{{
                  account.remain_requests == -1
                    ? "无限"
                    : account.remain_requests
                }}次
                <el-tooltip placement="bottom">
                  <div slot="content" class="prompt">
                    VIP到期后，剩余次数将保留7天。过期7天内续费，新购买的套餐次数会与过期的次数自动叠加。
                  </div>
                  <img
                    class="question_img"
                    src="@/assets/images/question.svg"
                  />
                  <!-- <i class="el-icon-warning-outline" ></i> -->
                </el-tooltip>
              </div>
              <!-- <div class="account_box">回复长度限制：{{account.maxlen==-1?'无限制':account.maxlen+"字"}}</div> -->
              <div class="account_box">
                连续多轮对话：{{ account.multi_turn == 0 ? "不支持" : "支持" }}

                <el-tooltip placement="bottom">
                  <div slot="content" class="prompt">
                    在多轮对话状态下，AI会记忆历史对话，因此用户可以针对上一轮AI的回复展开追问。例如可以追问“继续写”、“总结下刚才的对话”、“把刚才你说的内容转成英文”等。
                    <span class="multichatexample" @click="dialogexample = true"
                      >点击查看多轮对话示例</span
                    >
                  </div>
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
              <div class="account_box">
                到期时间：{{
                  account.expire_date == -1 ? "-" : account.expire_date
                }}
              </div>
              <div
                class="account_box2 account_box"
                v-if="account.human_support != 0"
              >
                有问题？<span class="lxkf" @click="dialogD = true"
                  >联系专属客服</span
                >
              </div>
            </div>
            <img
              class="img"
              style="display: block"
              @mouseenter="handleMouseEnter"
              @mouseleave="handleMouseLeave"
              src="@/assets/images/huiyuan.svg"
            />
          </el-tooltip>
          你好！{{ account.username }}
        </div>
        <div class="box" v-if="account.username">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <div class="name">{{ account.username["0"] }}</div>
              <i v-if="!isMobile" class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">个人中心</el-dropdown-item>
              <el-dropdown-item command="2">历史对话</el-dropdown-item>
              <el-dropdown-item command="3">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <router-view />

    <el-dialog
      :close-on-click-modal="false"
      title="扫码添加专属客服微信"
      :width="isMobile ? '90%' : '402px'"
      :visible.sync="dialogD"
    >
      <div class="dialog_box" style="text-align: center">
        <img src="@/assets/images/new/kf.jpg" class="kf_img" />
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="true"
      title="多轮对话示例"
      :width="isMobile ? '90%' : '700px'"
      :visible.sync="dialogexample"
    >
      <div class="demo-image__lazy" v-if="!isMobile">
        <el-image v-for="url in urls" :key="url" :src="url" lazy></el-image>
      </div>
      <div class="demo-image__lazy" v-else>
        <el-image
          v-for="mobile_url in mobile_urls"
          :key="mobile_url"
          :src="mobile_url"
          lazy
        ></el-image>
      </div>
    </el-dialog>

    <div class="right-bottom-sticky">
      <el-popover
        :width="160"
        placement="left-end"
        trigger="hover"
        popper-class="service-popover-small"
      >
        <template #reference>
          <a href="" class="cs-link" @click.prevent="">
            <img src="@/assets/images/new/cs.png" />
            <p>遇到问题？</p></a
          >
        </template>
        <div class="cs-content">
          <!-- <p class="title">遇到问题？联系客服</p> -->
          <img src="@/assets/images/new/kf.jpg" />
          <p>请使用微信扫码</p>
        </div>
      </el-popover>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      class="common-dialog"
      :width="isMobile ? '90%' : '600px'"
      :visible.sync="wxDialogShow"
      @closed="handleWxClose"
    >
      <div class="wx-content">
        <div class="title">添加客服，加入高质量AI工具交流群！</div>
        <div class="subtitle">
          涵盖ChatGPT、Claude、MJ绘画、Sora视频生成、AI+科研论文、AI写代码、AI+法律、AI+电商、AI写公文、AI写小说、AI+新媒体运营等数十个AI垂直话题，已有上万人
        </div>
        <div class="bd">
          <img src="@/assets/images/new/kf_zl.jpg" class="qrcode" />
        </div>
        <a href="" class="btn" @click.prevent="wxDialogShow = false">知道了</a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { payAccountcheck, logout } from "@/api";

const defaultTitle = "Claude-3";

export default {
  data() {
    return {
      dialogD: false,
      dialogexample: false,

      urls: [
        require("@/assets/images/example1.png"),
        require("@/assets/images/example2.png"),
        require("@/assets/images/example3.png"),
        require("@/assets/images/example4.png"),
      ],
      mobile_urls: [
        require("@/assets/images/me1.jpg"),
        require("@/assets/images/me2.jpg"),
        require("@/assets/images/me3.jpg"),
        require("@/assets/images/me4.jpg"),
      ],
      account: {},
      fetched: false,
      title: defaultTitle,
      navigationList: [
        {
          title: "找点灵感",
          icon: "el-icon-magic-stick",
        },
        {
          title: "快速出稿",
          icon: "el-icon-document",
        },
        {
          title: "稿件润色",
          icon: "el-icon-edit-outline",
        },
        {
          title: "定位Bug",
          icon: "el-icon-dwbug",
        },
      ],
      wxDialogShow: false,
      isFirstShow: false
    };
  },
  computed: {
    navigationActive() {
      return this.$route.query.navigationActive || 0;
    },
  },
  watch: {
    $route() {
      this.title = defaultTitle;
    },
  },
  beforeCreate() {
    this.$bus.$on("changeHeadTitle", (val) => {
      console.log("changeHeadTitle");
      this.title = val;
    });
  },
  mounted() {
    var that = this;
    that.getPayAccountcheck();
    if (this.$route.path === "/index" && this.$route.query.new) {
      this.wxDialogShow = true;
      this.isFirstShow = true
    }
  },
  methods: {
    toMy() {
      var that = this;
      that.$router.push({ path: "/my" });
    },
    getPayAccountcheck() {
      var that = this;
      payAccountcheck().then((res) => {
        if (res.code == 0) {
          that.account = res.result;
          that.fetched = true;
        }
      });
    },
    handleMouseEnter() {
      var that = this;
      if (!that.fetched) {
        that.getPayAccountcheck();
        that.fetched = true;
      }
    },

    handleMouseLeave() {
      var that = this;
      that.fetched = false;
    },
    handleCommand(command) {
      var that = this;
      if (command == 1) {
        that.$router.push({ path: "/my" });
      } else if (command == 2) {
        that.$router.push({ path: "/mychat" });
      } else if (command == 3) {
        if (that.isMobile) {
          logout().then((res) => {
            if (res.code == 0) {
              that.$router.push({ path: "/login" });
              localStorage.removeItem("enter_pay");
            }
          });
        } else {
          that
            .$confirm("确定要退出登录吗", "提示", {
              closeOnClickModal: false,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              logout().then((res) => {
                if (res.code == 0) {
                  that.$router.push({ path: "/login" });
                  localStorage.removeItem("enter_pay");
                }
              });
            })
            .catch(() => {});
        }
      }
    },
    handleWxClose() {
      if (this.isFirstShow) {
        this.$router.replace("/index");
        this.isFirstShow = false
      }
    },
  },
};
</script>
<style lang="less" scoped>
.prompt {
  // 必须设置宽度
  width: 270px;
  word-break: break-word;
  white-space: pre-line;
  clear: both;
  // text-align: center;
}
.multichatexample {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
}
.el-image {
  display: block;
  margin-bottom: 0;
}
.qun {
 margin-right: 10px;
 display: flex;
 flex-direction: column;
 align-items: center;
 line-height: 1;
 img {
    width: 28px;
 }
 p {
    font-size: 13px;
    color: #76787D;
 }
}
.apis-link { 
  margin-top: 2px;
  margin-right: 16px;
  img{
    width: 55px;
    display: block;
  }
}

.right-bottom-sticky {
  position: fixed;
  right: 16px;
  bottom: 52px;
  .cs-link {
    background: #fff;
    border: 1px solid #ebedef;
    width: 90px;
    height: 96px;
    border-radius: 4px;
    text-align: center;
    display: block;
    font-size: 14px;
    padding-top: 8px;
    color: #76787D;
    img {
        width: 48px;
    }
    p {
        text-indent: 10px;
    }
  }
}
.cs-content {
  .title {
    color: #ee5a53;
    font-size: 14px;
    margin-bottom: 10px;
  }
  img {
    width: 120px;
  }
  font-size: 12px;
  text-align: center;
}

.wx-content {
  padding: 30px;
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #ee5a53;
    text-align: center;
    margin-bottom: 10px;
  }
  .subtitle {
    font-size: 14px;
    text-align: center;
    margin-bottom: 20px;
  }
  .bd {
    text-align: center;
    margin-bottom: 10px;
  }
  .qrcode {
    width: 220px;
  }
  .btn {
    display: block;
    margin: 0 auto;
    width: 224px;
    height: 34px;
    text-align: center;
    border-radius: 8px;
    background: var(--color-1);
    color: #fff;
    font-size: 14px;
    line-height: 34px;
  }
}
@media only screen and (max-width: 1240px) {
.right-bottom-sticky {
    display: none;
  }
}
@media only screen and (max-width: 610px) {
  .apis-link { 
    margin-right: 10px;
    img{
      width: 50px;
    }
  }
  .qun {
    margin-right: 0;
    img {
        width: 22px;
    }
    p {
        font-size: 11px;
    }
  }
  .wx-content {
    padding: 25px;
    .title {
      font-size: 16px;
    }
    .subtitle {
      font-size: 14px;
    }
  }
}
</style>
